export default __webpack_public_path__ + "static/media/Language-TC.90742245.svg";